import React from 'react';
import { useTranslation } from 'react-i18next';

import { useActions } from '@mssgme/hooks';
import { useEnhancedFormik, FormField, Button } from '@mssgme/ui';

import styles from './styles.scss';

export default function RestoreForm() {
    const { t } = useTranslation('auth');
    const actions = useActions();
    const formik = useEnhancedFormik({
        initialValues: { email: '' },
        onSubmit: (payload) => actions.api.users.recoveryPassword({ payload }),
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <FormField
                builderInput
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                errors={t(formik.errors.email)}
                placeholder={t('auth.restore.placeholder')}
                type="email"
                style={{ height: 44, fontSize: 18 }}
                errorStyle={{ fontSize: 16, textAlign: 'center' }}
            />
            {formik.status === 'success' ? (
                <span className={styles.sentText}>{t('auth.restore.success')}</span>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        fullWidth
                        isFetching={formik.isSubmitting}
                        type="submit"
                        style={{
                            fontSize: 18,
                            fontWeight: 'bold',
                            backgroundColor: formik.isSubmitting ? 'transparent' : '#007aff',
                        }}
                    >
                        {t('auth.restore.button')}
                    </Button>
                </div>
            )}
        </form>
    );
}
